module.exports = __webpack_public_path__ + "img/page_activasolo_slider03.2237f263.png";